export interface IIssueInfoArticleRef {
    /** Derived from the first pageNumber of this section, so it is the same across language variants of the issue. */
    sectionId: string;

    sectionName: string;
    pageNumber: number;

    /**
     * primary article id or continuation article id
     */
    id: string;

    primaryArticleId: string;
    regionId: number;

    /** Regions which are continuation of an article on specific page. (Usually when article is spread across multiple pages). */
    continuationRegions: number[];
}

export interface IIssueInfoSectionRef {
    sectionId: string;
    sectionIdx: number;
    sectionName: string;
    pageNumbers: number[];
}

export type AnyIssueInfoContentRef = IIssueInfoArticleRef | IIssueInfoSectionRef;

export function isIssueInfoArticleRef(ref: AnyIssueInfoContentRef): ref is IIssueInfoArticleRef {
    return 'primaryArticleId' in ref;
}

export function isIssueInfoSectionRef(ref: AnyIssueInfoContentRef): ref is IIssueInfoSectionRef {
    return !isIssueInfoArticleRef(ref);
}
